import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api, { authStore } from "../lib/api";

/**
 * <HandoffIngest/> — mount once at App root. On every mount, checks the URL
 * hash fragment for `#t=<handoff_token>` (issued by /api/auth/handoff-issue on
 * the other device), exchanges it via /api/auth/handoff-consume for a real
 * session token, drops it into localStorage, strips the fragment, and routes
 * the user to their correct destination (home / wizard resume / new signup).
 */
export default function HandoffIngest() {
  const nav = useNavigate();
  const loc = useLocation();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (busy) return;
    const hash = window.location.hash || "";
    const match = hash.match(/[#&]t=([^&]+)/);
    if (!match) return;
    const handoff = decodeURIComponent(match[1]);
    setBusy(true);
    (async () => {
      try {
        const { data } = await api.post("/auth/handoff-consume", { handoff_token: handoff });
        authStore.save(data.token, data.user);
        // Strip the fragment so refresh doesn't retry
        const clean = window.location.pathname + window.location.search;
        window.history.replaceState({}, "", clean);
        toast.success("Session restored from your other device");
        const dest = data.route?.path
          ? (data.route.next_step ? `${data.route.path}?step=${data.route.next_step}` : data.route.path)
          : "/home";
        nav(dest, { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Session link expired");
        const clean = window.location.pathname + window.location.search;
        window.history.replaceState({}, "", clean);
      } finally { setBusy(false); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.pathname]);

  return null;
}
